import { render, staticRenderFns } from "./VDialogIntro.vue?vue&type=template&id=87f2ba28"
import script from "./VDialogIntro.vue?vue&type=script&lang=js"
export * from "./VDialogIntro.vue?vue&type=script&lang=js"
import style0 from "./VDialogIntro.vue?vue&type=style&index=0&id=87f2ba28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports